import dayjs from "dayjs";

export const ACORN_BRAND = "WILD ACORN FILMS";

export const ACORN_XHS_URL =
    "https://www.xiaohongshu.com/user/profile/63ff2097000000002a00ba2a";

export const ACORN_QUOTE_CATEGORIES = ["photography", "equipment", "travel", "other"];

export const ACORN_QUOTE_CURRENCIES = ["GBP", "CNY", "EUR", "USD"];

export const ACORN_DEFAULT_CURRENCY = "GBP";

export const ACORN_DEFAULT_GLOBAL_NOTES = [
    "超时费每小时100镑，超时15分钟内免费，超过15分钟按一小时计费",
];

let nextLineId = 0;

export function createAcornLineId() {
    nextLineId += 1;
    return `acorn-line-${nextLineId}`;
}

export function createAcornEmptyLine() {
    return {
        id: createAcornLineId(),
        name: "",
        unitPrice: "",
        quantity: 1,
        note: "",
    };
}

export function createDefaultAcornCategories() {
    return ACORN_QUOTE_CATEGORIES.reduce((acc, key) => {
        acc[key] = [createAcornEmptyLine()];
        return acc;
    }, {});
}

export function createDefaultAcornFormState() {
    return {
        projectName: "",
        quoteDate: dayjs(),
        validUntil: null,
        currency: ACORN_DEFAULT_CURRENCY,
        portfolioUrl: ACORN_XHS_URL,
        hideSubitemPrices: false,
        globalNotes: [...ACORN_DEFAULT_GLOBAL_NOTES],
        categories: createDefaultAcornCategories(),
    };
}
